import React from "react";
import styled from "styled-components";
import {Button, ListStyleNone, TextGradient} from "../../styles/globalStyles";
import {ReactComponent as Cb} from "../../assets/social/cb.svg";
import {ReactComponent as Facebook} from "../../assets/social/facebook.svg";
import {ReactComponent as Instagram} from "../../assets/social/instagram.svg";
import {ReactComponent as Linkedin} from "../../assets/social/linkedin.svg";
import {ReactComponent as Twitter} from "../../assets/social/twitter.svg";
import {device} from "../../styles/breakpoints";


const StyledFooter = styled.footer`
  margin-top: 5vh;
  background-color: #1B173A;
  width: 100%;
  padding: 5vh 5vw;
  @media ${device.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 5vh 15vw;
    gap: 30px
    

  }
`;

const SocialWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5vh;
`;

const NavigationWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  font-size: 12px;
`;


const H6 = styled.h6`
  font-size: 15px;
  @media ${device.tablet}{
    font-size: 20px;
  }
`;

const ListItem = styled.li`
  font-size: 10px;
  @media ${device.tablet}{
    font-size: 15px;
  }
`;
const Footer = () => {
  return (

    <StyledFooter>
      <div>
        <TextGradient as={'h1'}>Markai</TextGradient>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae quam sit scelerisque enim in sed diam nec,
          blandit. Amet tellus massa sed iaculis. Mauris, curabitur scelerisque.</p>
        <Button as={'button'}>Let's go</Button>
        <SocialWrapper>
          <Cb/>
          <Facebook/>
          <Instagram/>
          <Linkedin/>
          <Twitter/>
        </SocialWrapper>
      </div>
      <NavigationWrapper>
        <div>
          <H6>Site</H6>
          <ListStyleNone>
            <ListItem>Features</ListItem>
            <ListItem>Products</ListItem>
            <ListItem>Company</ListItem>
            <ListItem>Pricing</ListItem>
            <ListItem>Support</ListItem>
          </ListStyleNone>
        </div>
        <div>
          <H6>Legale</H6>
          <ListStyleNone>
            <ListItem>Privacy Policy</ListItem>
            <ListItem>Terms & Condition</ListItem>
            <ListItem>Company Policy</ListItem>
          </ListStyleNone>
        </div>
        <div>
          <H6>Company</H6>
          <ListStyleNone>
            <ListItem>About Us</ListItem>
            <ListItem>Our Team</ListItem>
            <ListItem>Out Story</ListItem>
            <ListItem>Career</ListItem>
          </ListStyleNone>
        </div>
        <div>
          <H6>Follow us one</H6>
          <ListStyleNone>
            <ListItem>Tweeter</ListItem>
            <ListItem>Facebook</ListItem>
            <ListItem>Linkedin</ListItem>
          </ListStyleNone>
        </div>
      </NavigationWrapper>
    </StyledFooter>

  )
};
export default Footer;
